import React, {useEffect, useRef} from "react";
import styles from "./UIMessageAudio.module.scss";

function UIMessageAudio(props : any) {
  const refProgress: any = useRef(false);
  const refLoadingProgress: any = useRef(false);
  const isAnother: any = props.isAnother;
  const audioDetailsLocal: any = props?.messageURLlocal?.audioDetails?.[0];
  let audioDetails: any = props?.messageDetails?.audioDetails?.[0];
  if(props?.messageDetails?.audioDetails) {
    audioDetails = props?.messageDetails?.audioDetails?.[0];
  }else if(props?.messageDetails?.fileDetails) {
    audioDetails = props?.messageDetails?.fileDetails?.[0];
  }
  let percent: any = {};
  const fileServiceDownloadURL: any =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";

  useEffect(() => {
    if (!audioDetails?.id && props?.uploadProgress?.length === 0)
      refLoadingProgress.current.style.display = "block";
    if (!audioDetails?.id && props?.uploadProgress?.length > 0) {
      if (
        props.uploadProgress?.filter(
          (item: any) => item?.tempMsgId === props?.tempMsgId
        ).length > 0
      ) {
        percent = props.uploadProgress?.filter(
          (item: any) => item?.tempMsgId === props?.tempMsgId
        )?.[0];
        refProgress.current.style.width = percent?.progress + "%";
      }
    }
    if (audioDetails?.id) refLoadingProgress.current.style.display = "none";
  }, [props?.uploadProgress, audioDetails]);

  return (
      <div className={isAnother > 1 ? styles.openGraph2 : styles.openGraph1}>
        <div
          className={styles.previewImg}
        >
          <div
            className={styles.myProgress}
            style={{
              display: audioDetails?.id ? "block" : "block",
            }}
          >
            <audio controls>
              <source src={!audioDetails?.id ? audioDetailsLocal : `${fileServiceDownloadURL}${audioDetails?.id}`}></source>
            </audio>
            <div ref={refLoadingProgress} className={styles.videoProgress}>
              <div ref={refProgress} className={styles.myBar}></div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default React.memo(UIMessageAudio);
